/* eslint-disable react/react-in-jsx-scope */
import { Toaster } from "sonner";
import { AppProvidersWrapper, BackToTop } from "./components";
import AllRoutes from "./routes/Routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// styles
import "@/assets/css/style.css";

const App = () => {
  return (
    <AppProvidersWrapper>
      <AllRoutes />
      <BackToTop />
      <ToastContainer />
      <Toaster richColors />
    </AppProvidersWrapper>
  );
};

export default App;
